module.exports = __webpack_public_path__ + "img/map.dd055c4a.png";